import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import ServiceSelection from "../../components/ServiceSelection/ServiceSelection";
import "./ServicesPage.scss";

function ServicesPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleServiceNext = (config) => {
    navigate("/upload", { state: { serviceConfig: config } });
  };

  const _email = auth.user?.profile?.email || auth.user?.profile?.sub || "User";

  return (
    <div className="sp-page">
      <main className="tab-panel">
        <ServiceSelection onNext={handleServiceNext} onBack={() => navigate("/dashboard")} />
      </main>
    </div>
  );
}

export default ServicesPage;
